import styles from './batchEditCampaignPage.module.scss';

export const BatchEditCampaignPage: React.FC<
  React.PropsWithChildren<{
    title: string;
  }>
> = ({ title, children }) => {
  return (
    <div className={styles.batchEditCampaignPage}>
      <h2>{title}</h2>
      {children}
    </div>
  );
};
